var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "roofing-24px_1_",
    "data-name": "roofing-24px (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29.799,
    viewBox: "0 0 30 29.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1",
    "data-name": "Caminho 1",
    d: "M29.4,30.727H4.751V32.8H29.4V30.727ZM27.5,13.393V8.827L23,8.939h0L17,3,2,17.847H4.406L17,5.385,29.844,17.847H32Z",
    transform: "translate(-2 -3)",
    fill: "#f8f9fa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12",
    "data-name": "Caminho 12",
    d: "M28.019,45.515H6.219v3.176h21.8V45.515Z",
    transform: "translate(-2 -24.849)",
    fill: "#f8f9fa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.dd9e59d175f1208446ab3f3e4d7fc51c.svg";
export { ForwardRef as ReactComponent };